module.exports = __webpack_public_path__ + "img/header-engagementRingsBudgetMedium@2x.bf66e0b.webp";